import React, { useState, useRef, useEffect } from 'react';
import { Dropdown, DropdownToggle, Nav, DropdownMenu } from 'reactstrap';
import { ReactComponent as InfoIcon } from '../../../assets/utils/images/svgs/InformationBlue.svg';

const HOVER_CLOSE_MS = 200;

const TitleModal = ({ data, title, Icon = <></>, variant, scopedBewaartermijnClass }) => {
  const [infoMenu, setInfoMenu] = useState(false);
  const modalRef = useRef(null);
  const btnRef = useRef(null);
  const closeTimerRef = useRef(null);
  const isBewaartermijn = variant === 'bewaartermijn';

  const clearCloseTimer = () => {
    if (closeTimerRef.current) {
      clearTimeout(closeTimerRef.current);
      closeTimerRef.current = null;
    }
  };

  const scheduleCloseMenu = () => {
    clearCloseTimer();
    closeTimerRef.current = setTimeout(() => setInfoMenu(false), HOVER_CLOSE_MS);
  };

  const keepOpenOrOpen = () => {
    clearCloseTimer();
    setInfoMenu(true);
  };

  const toggleDropdown = () => {
    if (isBewaartermijn) {
      setInfoMenu(false);
      return;
    }
    setInfoMenu((prev) => !prev);
  };

  useEffect(() => {
    return () => clearCloseTimer();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target) &&
        btnRef.current &&
        !btnRef.current.contains(event.target)
      ) {
        setInfoMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const hoverTriggerProps = isBewaartermijn
    ? { onMouseEnter: keepOpenOrOpen, onMouseLeave: scheduleCloseMenu }
    : {};

  const hoverMenuProps = isBewaartermijn
    ? { onMouseEnter: keepOpenOrOpen, onMouseLeave: scheduleCloseMenu }
    : {};

  const menuScope = isBewaartermijn && scopedBewaartermijnClass ? ` ${scopedBewaartermijnClass}` : '';

  return (
    <Dropdown isOpen={infoMenu} toggle={toggleDropdown} direction="down">
      <DropdownToggle color="link" className="p-0" innerRef={btnRef} {...hoverTriggerProps}>
        <div className={`cursor-pointer ${title === 'Memo' ? 'd-flex' : ''}`}>
          {title === 'Memo' ? (
            <Icon />
          ) : (
            title === 'Bericht' ? <Icon /> : <InfoIcon />
          )}
        </div>
      </DropdownToggle>
      <DropdownMenu
        className={`rm-pointers p-0 weekstaten-popup-border${isBewaartermijn ? ` bewaartermijn-popup${menuScope}` : ''}`}
        innerRef={modalRef}
        {...hoverMenuProps}
      >
        <Nav className={`weekstaten-popup-width flex-column${isBewaartermijn ? ' bewaartermijn-popup__nav p-0' : ' p-2'}`}>
          {isBewaartermijn ? (
            <>
              <div className="bewaartermijn-popup__title">{title}</div>
              <hr className="bewaartermijn-popup__divider" />
              <div className="bewaartermijn-popup__body text-break">{data}</div>
              <hr className="bewaartermijn-popup__divider" />
            </>
          ) : (
            <>
              <div className="btn-color-style travelCost-blue-text mb-2 ps-2">{title}</div>
              <div className="travelCost-light-text ps-2 text-break">{data}</div>
            </>
          )}
        </Nav>
      </DropdownMenu>
    </Dropdown>
  );
};

export default TitleModal;
